import React from 'react';
import PropTypes from 'prop-types';

/**
 * Framed, captioned figure slot for the integration guide.
 *
 * Renders nothing until `src` is provided, so unfinished slots never ship a
 * placeholder to production. Drop an exported visual into `src` to light it up.
 * Pass `frame={false}` for transparent artwork that carries its own shadow.
 */
const DocsFigure = ({
  src,
  alt,
  caption,
  aspectRatio = '16 / 9',
  frame = true,
  className,
}) => {
  if (!src) return null;

  return (
    <figure className={`docs-figure${className ? ` ${className}` : ''}`}>
      <div
        className={`docs-figure-frame${frame ? '' : ' is-bare'}`}
        style={{ '--docs-figure-ar': aspectRatio }}
      >
        <img src={src} alt={alt} className="docs-figure-img" loading="lazy" />
      </div>
      {caption ? (
        <figcaption className="docs-figure-caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
};

DocsFigure.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  caption: PropTypes.node,
  aspectRatio: PropTypes.string,
  frame: PropTypes.bool,
  className: PropTypes.string,
};

export default DocsFigure;
